import { useEffect } from 'react';
import { axiosCred } from '../services/axios';
import useRefresh from './useRefresh';
import { AxiosRequestConfig } from 'axios';

const useAxios = (
  accessToken: string,
  setAccessToken: (token: string) => void
) => {
  const refresh = useRefresh(setAccessToken);

  useEffect(() => {
    const requestIntercept = axiosCred.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        if (!config.headers?.Authorization) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          config.headers!.Authorization = accessToken;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosCred.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers.Authorization = `${newAccessToken}`;
          return axiosCred(prevRequest);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosCred.interceptors.request.eject(requestIntercept);
      axiosCred.interceptors.response.eject(responseIntercept);
    };
  }, [accessToken, setAccessToken, refresh]);

  return axiosCred;
};

export default useAxios;
